'use strict';

/**
 * Available snackbar positions on the screen
 */ var SNACKBAR_POSITIONS = /*#__PURE__*/ function(SNACKBAR_POSITIONS) {
    SNACKBAR_POSITIONS["topRight"] = "topRight";
    SNACKBAR_POSITIONS["topLeft"] = "topLeft";
    SNACKBAR_POSITIONS["topCenter"] = "topCenter";
    SNACKBAR_POSITIONS["bottomRight"] = "bottomRight";
    SNACKBAR_POSITIONS["bottomLeft"] = "bottomLeft";
    SNACKBAR_POSITIONS["bottomCenter"] = "bottomCenter";
    return SNACKBAR_POSITIONS;
}(SNACKBAR_POSITIONS || {});
/**
 * Available snackbar visual variants
 */ var SNACKBAR_VARIANTS = /*#__PURE__*/ function(SNACKBAR_VARIANTS) {
    SNACKBAR_VARIANTS["info"] = "info";
    SNACKBAR_VARIANTS["success"] = "success";
    SNACKBAR_VARIANTS["critical"] = "critical";
    return SNACKBAR_VARIANTS;
}(SNACKBAR_VARIANTS || {});

exports.SNACKBAR_POSITIONS = SNACKBAR_POSITIONS;
exports.SNACKBAR_VARIANTS = SNACKBAR_VARIANTS;
//# sourceMappingURL=InternalSnackbar.web.types.cjs.map
